<p class="onboarding-welcome text-center">
    {{ 'modals.store_link_after_linking.title' | translate:{ name: userName } }}
</p>

<div class="onboarding-layout">
    <div class="onboarding-copy">
        <section class="text-card description-card">
            <p class="text-center">{{ 'modals.store_link_after_linking.step1' | translate }}</p>
            <p class="text-center">{{ 'modals.store_link_after_linking.step2' | translate }}</p>
        </section>
    </div>
</div>
